import "ace-builds/src-noconflict/ace";
import "ace-builds/src-noconflict/ext-language_tools";
import "ace-builds/src-noconflict/mode-java";
import "ace-builds/src-noconflict/theme-github";
import AceEditor from "react-ace";
import { Controller, useFormContext } from "react-hook-form";
import { Form } from "semantic-ui-react";

import "components/TextEditor/TextEditor.scss";
import "lib/Form/components/FormTextEditor/FormTextEditorStyle.scss";

import type { FieldValues, Path } from "react-hook-form";
import type { FormFieldProps } from "semantic-ui-react";

type ShallowPath<T> = keyof T & string;

type FormTextEditorProps<T extends FieldValues> = {
  name: ShallowPath<T>;
  formFieldProps?: FormFieldProps;
  editorProps?: React.ComponentProps<typeof AceEditor>;
};

export const FormTextEditor = <T extends FieldValues>({ name, editorProps, formFieldProps }: FormTextEditorProps<T>) => {
  const methods = useFormContext<T>();

  return (
    <Controller
      name={name as Path<T>}
      {...methods}
      render={({ field, fieldState: { invalid } }) => (
        <Form.Field {...formFieldProps}>
          <div className={`aceEditorContainer ${invalid ? "aceEditorContainerInvalid" : ""}`}>
            <AceEditor
              placeholder={editorProps?.placeholder || "Enter Message"}
              {...field}
              mode="java"
              theme="github"
              name={name}
              editorProps={{ $blockScrolling: true }}
              className="aceEditor"
              {...editorProps}
            />
          </div>
        </Form.Field>
      )}
    />
  );
};
